module.exports = __webpack_public_path__ + "img/thumbnail-textgradient.ad593d29.webp";